import { db } from "../../config/firebaseInitial";
import "firebase/auth";
import firebase from "firebase/app";

export const MAIN_CARDS_REQUEST = "MAIN_CARDS_REQUEST";
export const MAIN_CARDS_SUCCESS = "MAIN_CARDS_SUCCESS";
export const MAIN_CARDS_FAILURE = "MAIN_CARDS_FAILURE";
export const MAIN_CARDS_UPDATE = "MAIN_CARDS_UPDATE";
export const MAIN_CARDS_DELETE = "MAIN_CARDS_DELETE";
export const MAIN_CARDS_LISTENER = "MAIN_CARDS_LISTENER";
export const MAIN_CARDS_ADD = "MAIN_CARDS_ADD";

export const HAS_MORE = "HAS_MORE";

const requestMainCards = () => {
  return {
    type: MAIN_CARDS_REQUEST
  };
};

const receiveMainCards = (maincards, lastCard) => {
  return {
    type: MAIN_CARDS_SUCCESS,
    maincards,
    lastCard
  };
};

const mainCardsError = error => {
  return {
    type: MAIN_CARDS_FAILURE,
    error
  };
};
const updateMainCards = (id, data) => {
  return {
    type: MAIN_CARDS_UPDATE,
    id,
    data
  };
};
const addMainCards = (id, data) => {
  return {
    type: MAIN_CARDS_ADD,
    id,
    data
  };
};
const deleteFromMainCards = id => {
  return {
    type: MAIN_CARDS_DELETE,
    id
  };
};

const addMainCardsListener = listener => {
  return {
    type: MAIN_CARDS_LISTENER,
    listener
  };
};

export const setHasMore = value => {
  return {
    type: HAS_MORE,
    value
  };
};
export const firstFetchMainCards = () => dispatch => {
  dispatch(requestMainCards());
  let firstListen = true;

  let listener = db
    .collection("cards")
    .orderBy("timestamp")
    .where("cardStatus", "==", "pending")
    .limit(6)
    .onSnapshot(
      function (querySnapshot) {
        if (querySnapshot.docs.length === 0) {
          dispatch(setHasMore(false));
        } else {
          if (firstListen) {
            dispatch(setHasMore(true));
            var lastCard = querySnapshot.docs[querySnapshot.docs.length - 1];
            let cards = {};
            querySnapshot.docs.map(doc => (cards[doc.id] = doc.data()));
            dispatch(receiveMainCards(cards, lastCard));
            firstListen = false;
          } else {
            querySnapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                dispatch(addMainCards(change.doc.id, change.doc.data()));
              }
              if (change.type === "modified") {
                dispatch(updateMainCards(change.doc.id, change.doc.data()));
                if (isCardInProgress(change.doc.data().needs)) {
                  updateCardStatus(change.doc.id, "inprogress", dispatch);
                }
              }
              if (change.type === "removed") {
                dispatch(deleteFromMainCards(change.doc.id));
              }
            });
          }
        }
      },
      error => {
        dispatch(mainCardsError(error));
      }
    );
  if (listener) dispatch(addMainCardsListener(listener));
};

export const nextFetchMainCards = lastMainCard => dispatch => {
  dispatch(requestMainCards());
  let firstListen = true;

  let listener = db
    .collection("cards")
    .orderBy("timestamp")
    .startAfter(lastMainCard)
    .where("cardStatus", "==", "pending")
    .limit(6)
    .onSnapshot(
      function (querySnapshot) {
        if (querySnapshot.docs.length === 0) {
          dispatch(setHasMore(false));
        } else {
          if (firstListen) {
            dispatch(setHasMore(true));
            var lastCard = querySnapshot.docs[querySnapshot.docs.length - 1];
            let cards = {};
            querySnapshot.docs.map(doc => (cards[doc.id] = doc.data()));
            dispatch(receiveMainCards(cards, lastCard));
            firstListen = false;
          } else {
            querySnapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                dispatch(addMainCards(change.doc.id, change.doc.data()));
              }
              if (change.type === "modified") {
                dispatch(updateMainCards(change.doc.id, change.doc.data()));
                if (isCardInProgress(change.doc.data().needs))
                  updateCardStatus(change.doc.id, "inprogress", dispatch);
              }
              if (change.type === "removed") {
                dispatch(deleteFromMainCards(change.doc.id));
              }
            });
          }
        }
      },
      error => {
        dispatch(mainCardsError(error));
      }
    );
  if (listener) dispatch(addMainCardsListener(listener));
};

export const PROFILE_CARDS_REQUEST = "PROFILE_CARDS_REQUEST";
export const PROFILE_CARDS_SUCCESS = "PROFILE_CARDS_SUCCESS";
export const PROFILE_CARDS_FAILURE = "PROFILE_CARDS_FAILURE";
export const PROFILE_CARDS_UPDATE = "PROFILE_CARDS_UPDATE";
export const PROFILE_CARDS_DELETE = "PROFILE_CARDS_DELETE";
export const PROFILE_CARDS_LISTENER = "PROFILE_CARDS_LISTENER";
export const PROFILE_CARDS_ADD = "PROFILE_CARDS_ADD";

const requestProfileCards = () => {
  return {
    type: PROFILE_CARDS_REQUEST
  };
};

const receiveProfileCards = (profileCards, lastCard) => {
  return {
    type: PROFILE_CARDS_SUCCESS,
    profileCards,
    lastCard
  };
};

const profileCardsError = error => {
  return {
    type: PROFILE_CARDS_FAILURE,
    error
  };
};

const updateProfileCards = (id, data) => {
  return {
    type: PROFILE_CARDS_UPDATE,
    id,
    data
  };
};
const addProfileCards = (id, data) => {
  return {
    type: PROFILE_CARDS_ADD,
    id,
    data
  };
};

const deleteFromProfileCards = id => {
  return {
    type: PROFILE_CARDS_DELETE,
    id
  };
};

const addProfileCardsListener = listener => {
  return {
    type: PROFILE_CARDS_LISTENER,
    listener
  };
};

export const firstFetchProfileCards = currentUser => dispatch => {
  dispatch(requestProfileCards());
  let firstListen = true;

  let listener = db
    .collection("cards")
    .orderBy("timestamp")
    .where("workerCard", "array-contains", { [currentUser]: "WorkingOnIt" })
    .limit(6)
    .onSnapshot(
      function (querySnapshot) {
        if (querySnapshot.docs.length === 0) {
          dispatch(setHasMore(false));
        } else {
          if (firstListen) {
            dispatch(setHasMore(true));
            var lastCard = querySnapshot.docs[querySnapshot.docs.length - 1];
            let cards = {};
            querySnapshot.docs.map(doc => (cards[doc.id] = doc.data()));
            dispatch(receiveProfileCards(cards, lastCard));
            firstListen = false;
          } else {
            querySnapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                dispatch(addProfileCards(change.doc.id, change.doc.data()));
              }
              if (change.type === "modified") {
                dispatch(updateProfileCards(change.doc.id, change.doc.data()));
                if (isCardCompleted(change.doc.data().needs, "completed")) {
                  updateCardStatus(change.doc.id, "completed");
                }
                if (
                  !isWorkerBelongToCard(change.doc.data().needs, currentUser)
                ) {
                  deleteCardWorker(change.doc.id, currentUser);
                }
                if (isWorkerCompleted(change.doc.data().needs, currentUser)) {
                  updateCardWorker(
                    change.doc.id,
                    currentUser,
                    change.doc.data().workerCard
                  );
                }
              }
              if (change.type === "removed") {
                dispatch(deleteFromProfileCards(change.doc.id));
              }
            });
          }
        }
      },
      error => {
        dispatch(profileCardsError(error));
      }
    );
  if (listener) dispatch(addProfileCardsListener(listener));
};

export const NextFetchProfileCards = (
  currentUser,
  lastProfileCard
) => dispatch => {
  dispatch(requestProfileCards());
  let firstListen = true;

  let listener = db
    .collection("cards")
    .orderBy("timestamp")
    .startAfter(lastProfileCard)
    .where("workerCard", "array-contains", { [currentUser]: "WorkingOnIt" })
    .limit(6)
    .onSnapshot(
      function (querySnapshot) {
        if (querySnapshot.docs.length === 0) {
          dispatch(setHasMore(false));
        } else {
          if (firstListen) {
            dispatch(setHasMore(true));

            var lastCard = querySnapshot.docs[querySnapshot.docs.length - 1];
            let cards = {};
            querySnapshot.docs.map(doc => (cards[doc.id] = doc.data()));
            dispatch(receiveProfileCards(cards, lastCard));
            firstListen = false;
          } else {
            querySnapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                dispatch(addProfileCards(change.doc.id, change.doc.data()));
              }
              if (change.type === "modified") {
                dispatch(updateProfileCards(change.doc.id, change.doc.data()));
                if (isCardCompleted(change.doc.data().needs, "completed")) {
                  updateCardStatus(change.doc.id, "completed");
                }
                if (
                  !isWorkerBelongToCard(change.doc.data().needs, currentUser)
                ) {
                  deleteCardWorker(change.doc.id, currentUser);
                }
                if (isWorkerCompleted(change.doc.data().needs, currentUser)) {
                  updateCardWorker(
                    change.doc.id,
                    currentUser,
                    change.doc.data().workerCard
                  );
                }

                // dispatch(deleteFromProfileCards(change.doc.id));
              }
              if (change.type === "removed") {
                dispatch(deleteFromProfileCards(change.doc.id));
              }
            });
          }
        }
      },
      error => {
        dispatch(profileCardsError(error));
      }
    );
  if (listener) dispatch(addProfileCardsListener(listener));
};

////clear the state of cards
export const CANCEL_MAIN_CARDS_LISTENER = "CANCEL_MAIN_CARDS_LISTENER";

export const cancelMainCardsListener = () => {
  return {
    type: CANCEL_MAIN_CARDS_LISTENER
  };
};

export const CANCEL_PROFILE_CARDS_LISTENER = "CANCEL_PROFILE_CARDS_LISTENER";

export const cancelProfileCardsListener = () => {
  return {
    type: CANCEL_PROFILE_CARDS_LISTENER
  };
};

////////// helpeeeers

const isCardCompleted = (needs, status) =>
  Object.keys(needs).every(need => needs[need].needStatus === status);

const isCardInProgress = needs =>
  Object.keys(needs).every(
    need => needs[need].needStatus === ("inprogress" || "completed")
  );
const isWorkerBelongToCard = (needs, userId) =>
  Object.keys(needs).some(need => needs[need].uid === userId);

const isWorkerCompleted = (needs, workerId) => {
  let workerNeeds = Object.keys(needs).filter(
    need => needs[need].uid === workerId
  );
  let result = workerNeeds.length
    ? workerNeeds.every(need => needs[need].needStatus === "completed")
    : false;
  return result;
};

const updateCardStatus = (id, status) =>
  db
    .collection("cards")
    .doc(id)
    .update({ cardStatus: status })
    .catch(error => { });

const deleteCardWorker = (id, workerId) => {
  db.collection("cards")
    .doc(id)
    .update({
      workerCard: firebase.firestore.FieldValue.arrayRemove({
        [workerId]: "WorkingOnIt"
      })
    })
    .catch(error => { });
};
const updateCardWorker = (id, workerId, workers) => {
  let worker = workers.findIndex(item => item[workerId] === "WorkingOnIt");
  workers[worker] = { [workerId]: "Done" };

  db.collection("cards")
    .doc(id)
    .update({
      workerCard: workers
    })
    .catch(error => { });
};
export const locToMap = locArr => {
  return {
    type: "LOC_TO_MAP",
    value: locArr
  };
};
// fetch profile cards for the navbar
export const NAV_PROFILE_CARDS = "NAV_PROFILE_CARDS";
const navcards = navcards => {
  return {
    type: NAV_PROFILE_CARDS,
    value: navcards
  };
};
export const fetchNavProfileCards = currentUser => dispatch => {
  db.collection("cards")
    .orderBy("timestamp")
    .where("workerCard", "array-contains", { [currentUser]: "WorkingOnIt" })
    .limit(6)
    .onSnapshot(function (querySnapshot) {
      let cards = {};
      querySnapshot.docs.map(doc => (cards[doc.id] = doc.data()));
      dispatch(navcards(cards));
    });
};
